(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-split"] && !Shopify.designMode) return;
  try {
    
  function initAccordionSplit(scope) {
    (scope || document).querySelectorAll('.accordion-split__trigger').forEach((trigger) => {
      if (trigger.dataset.accordionSplitBound === 'true') return;
      trigger.dataset.accordionSplitBound = 'true';

      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const panel = trigger.nextElementSibling;
        const item = trigger.closest('.accordion-split__item');

        trigger.setAttribute('aria-expanded', String(!isExpanded));
        if (panel) panel.setAttribute('aria-hidden', String(isExpanded));
        if (item) item.classList.toggle('accordion-split__item--open', !isExpanded);
      });
    });

    // Swap the cover for the player on click, so nothing loads until then.
    // Pop-up and link covers are handled by the video-popup snippet or the browser.
    (scope || document).querySelectorAll('[data-accordion-split-play]').forEach((button) => {
      if (button.dataset.accordionSplitBound === 'true') return;
      button.dataset.accordionSplitBound = 'true';

      button.addEventListener('click', () => {
        const media = button.closest('.accordion-split__media');
        const template = media && media.querySelector('template');
        if (!template) return;

        media.appendChild(template.content.cloneNode(true));
        button.remove();

        const player = media.querySelector('iframe, video');
        if (!player) return;
        player.focus();
        if (player.tagName === 'VIDEO') player.play().catch(() => {});
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAccordionSplit());
  } else {
    initAccordionSplit();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => initAccordionSplit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Initialize cart functionality
  document.addEventListener('DOMContentLoaded', () => {
    const cartForm = document.getElementById('cart-form');
    const deleteModal = document.getElementById('delete-modal');
    let pendingRemoveUrl = null;
    
    if (!cartForm) return;

    // Quantity controls
    const quantityButtons = document.querySelectorAll('.cart-item__quantity-button');
    const quantityInputs = document.querySelectorAll('.cart-item__quantity-input');
    
    quantityButtons.forEach(button => {
      button.addEventListener('click', () => {
        const action = button.getAttribute('data-action');
        const line = button.getAttribute('data-line');
        const input = document.querySelector(`input[data-line="${line}"]`);
        
        if (!input) return;
        
        let currentValue = parseInt(input.value);
        
        if (action === 'increase') {
          input.value = currentValue + 1;
          updateCart();
        } else if (action === 'decrease') {
          if (currentValue === 1) {
            // If quantity is 1, show delete confirmation modal instead
            const lineItem = button.closest('.cart-item');
            const removeButton = lineItem.querySelector('.cart-item__remove');
            pendingRemoveUrl = removeButton.getAttribute('data-line-item-url');
            openModal();
          } else if (currentValue > 1) {
            input.value = currentValue - 1;
            updateCart();
          }
        }
      });
    });

    // Manual quantity input change
    quantityInputs.forEach(input => {
      let timeout;
      input.addEventListener('input', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          updateCart();
        }, 500);
      });
    });

    // Remove item
    const removeButtons = document.querySelectorAll('.cart-item__remove');
    
    removeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        pendingRemoveUrl = button.getAttribute('data-line-item-url');
        openModal();
      });
    });

    // Modal controls
    function openModal() {
      deleteModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      deleteModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      pendingRemoveUrl = null;
    }

    // Modal button handlers
    const cancelButton = deleteModal.querySelector('[data-action="cancel"]');
    const confirmButton = deleteModal.querySelector('[data-action="confirm"]');
    const modalOverlay = deleteModal.querySelector('.cart-modal__overlay');

    cancelButton.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', closeModal);

    confirmButton.addEventListener('click', () => {
      if (pendingRemoveUrl) {
        window.location.href = pendingRemoveUrl;
      }
    });

    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && deleteModal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    // Update cart function
    async function updateCart() {
      const formData = new FormData(cartForm);
      
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          // Reload page to show updated cart
          window.location.reload();
        } else {
          console.error('Failed to update cart');
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Filter toggle functionality
  document.addEventListener('DOMContentLoaded', function() {
    const filterToggle = document.querySelector('.collection-page__filter-toggle');
    const filters = document.querySelector('.collection-page__filters');
    const sortContainer = document.querySelector('.collection-page__sort');

    if (filterToggle && filters) {
      // Check if filter params exist in URL
      const urlParams = new URLSearchParams(window.location.search);
      const hasFilterParams = urlParams.has('filter.v.availability') || 
                              urlParams.has('filter.v.price.gte') || 
                              urlParams.has('filter.v.price.lte') ||
                              Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));
      
      // Initialize state: if filters are active in URL, show them; otherwise closed by default
      if (hasFilterParams) {
        filters.hidden = false;
        filterToggle.setAttribute('aria-expanded', 'true');
        // On mobile, also show sort when filters are active
        if (window.innerWidth <= 768) {
          if (sortContainer) sortContainer.hidden = false;
        }
      } else {
        filters.hidden = true;
        filterToggle.setAttribute('aria-expanded', 'false');
        // On mobile, hide sort by default
        if (window.innerWidth <= 768) {
          if (sortContainer) sortContainer.hidden = true;
        }
      }
      
      // On desktop, always show sort
      if (window.innerWidth > 768) {
        if (sortContainer) sortContainer.hidden = false;
      }

      filterToggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        filters.hidden = isExpanded;
        
        // Only toggle sort on mobile
        if (window.innerWidth <= 768) {
          if (sortContainer) sortContainer.hidden = isExpanded;
        }
      });

      // Handle resize events
      window.addEventListener('resize', function() {
        const isExpanded = filterToggle.getAttribute('aria-expanded') === 'true';
        
        if (window.innerWidth > 768) {
          // Desktop: always show sort, respect filter toggle state
          if (sortContainer) sortContainer.hidden = false;
          filters.hidden = !isExpanded;
        } else {
          // Mobile: tie sort to filter toggle state
          filters.hidden = !isExpanded;
          if (sortContainer) sortContainer.hidden = !isExpanded;
        }
      });
    }

    // Sort functionality
    const sortSelect = document.querySelector('.collection-page__sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    // Auto-submit filters on change
    const filterForm = document.querySelector('.collection-filters');
    if (filterForm) {
      const filterInputs = filterForm.querySelectorAll('input[type="checkbox"], input[type="number"]');
      filterInputs.forEach(input => {
        input.addEventListener('change', function() {
          // Debounce for number inputs
          if (this.type === 'number') {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
              filterForm.submit();
            }, 500);
          } else {
            filterForm.submit();
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  /**
   * Contact form controller.
   *
   * Shows and hides the patient/provider branches, and posts the result to
   * n8n as JSON.
   *
   * Branch visibility is driven by the `disabled` attribute on <fieldset>,
   * not by CSS alone. A disabled fieldset excludes its descendants from both
   * form submission and constraint validation, so a hidden `required` field
   * can never silently block submit, and a hidden text field can never smuggle
   * a value into the payload. `hidden` is applied alongside it purely for
   * presentation.
   */
  class ContactForm {
    constructor(form) {
      this.form = form;
      this.endpoint = form.dataset.endpoint;
      this.wrapper = form.closest('.contact-section__form-wrapper');
      this.success = this.wrapper.querySelector('[data-contact-success]');
      this.error = this.wrapper.querySelector('[data-contact-error]');
      this.submit = form.querySelector('button[type="submit"]');
      this.submitWrap = form.querySelector('.contact-section__submit');
      this.submitLabel = this.submit.querySelector('.button-pill__text');
      this.defaultLabel = this.submitLabel.textContent;
      this.sendingLabel = form.dataset.sendingLabel || this.defaultLabel;

      this.phone = form.querySelector('[data-phone]');
      this.phoneMarker = form.querySelector('[data-phone-required-marker]');
      this.phoneInvalidMsg = form.dataset.phoneInvalid || 'Please enter a valid phone number.';

      this.branches = {};
      form.querySelectorAll('[data-branch]').forEach((el) => {
        this.branches[el.dataset.branch] = el;
      });

      this.bind();
      this.syncBranches();
    }

    bind() {
      this.form
        .querySelector('[data-inquiry-type]')
        .addEventListener('change', () => this.syncBranches());

      this.form
        .querySelectorAll(
          '[data-provider-partner], [data-provider-prospect-path], [data-patient-reason], [data-patient-existing]'
        )
        .forEach((el) => {
          el.addEventListener('change', () => this.syncBranches());
        });

      this.form.querySelectorAll('[data-other-toggle]').forEach((el) => {
        el.addEventListener('change', () => this.syncOtherField(el));
      });

      // Preferred contact method decides whether the phone field is required;
      // re-check the phone itself as they type so the error clears live.
      this.form.querySelectorAll('[data-contact-method]').forEach((el) => {
        el.addEventListener('change', () => this.syncPhoneValidation());
      });
      this.phone.addEventListener('input', () => this.syncPhoneValidation());

      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    setBranch(name, active) {
      const branch = this.branches[name];
      if (!branch) return;
      branch.hidden = !active;
      branch.disabled = !active;
    }

    syncBranches() {
      const type = this.form.querySelector('[data-inquiry-type]').value;
      const isPatient = type === 'patient';
      const isProvider = type === 'provider';

      this.setBranch('patient', isPatient);
      this.setBranch('provider', isProvider);

      // Patient: reveal the matching second-level reason group.
      const reasonEl = this.form.querySelector('[data-patient-reason]:checked');
      const reason = isPatient && reasonEl ? reasonEl.value : null;
      this.setBranch('patient-sub-general', reason === 'general_question');
      this.setBranch('patient-sub-consult', reason === 'consultation');
      this.setBranch('patient-sub-other', reason === 'something_else');
      // Refills get a link to the Refill Rx portal instead of a second question.
      this.setBranch('patient-refill-link', reason === 'refill_status');

      // Date of birth is only asked of patients who say they're already with us.
      const existingEl = this.form.querySelector('[data-patient-existing]:checked');
      const existing = isPatient && existingEl ? existingEl.value : null;
      this.setBranch('patient-dob', existing === 'yes');

      // Provider: partner -> free text; prospect -> gate (account vs. questions).
      const partnerEl = this.form.querySelector('[data-provider-partner]:checked');
      const partner = isProvider && partnerEl ? partnerEl.value : null;
      this.setBranch('provider-partner', partner === 'yes');
      this.setBranch('provider-prospect-gate', partner === 'no');

      const pathEl = this.form.querySelector('[data-provider-prospect-path]:checked');
      const path = partner === 'no' && pathEl ? pathEl.value : null;
      this.setBranch('provider-prospect-account', path === 'create_account');
      this.setBranch('provider-prospect', path === 'general_info');

      this.syncRefillNotice();
      this.syncPhoneValidation();
      // Creating an account is a link-out, so there's nothing to submit here.
      this.submitWrap.hidden = path === 'create_account';
    }

    /**
     * The phone field lives in the shared identity block and is optional by
     * default. When the active branch's preferred contact method is Phone or
     * Text, it becomes required and must look like a real number. Email needs
     * nothing extra — it is always required and type="email" already.
     *
     * The active method is the checked radio not sitting inside a disabled
     * <fieldset> (i.e. belonging to the branch currently on screen).
     */
    syncPhoneValidation() {
      const method = Array.from(this.form.querySelectorAll('[data-contact-method]:checked'))
        .find((el) => !el.closest('fieldset[disabled]'));
      const needsPhone = !!method && (method.value === 'phone' || method.value === 'text');

      this.phone.required = needsPhone;
      this.phoneMarker.hidden = !needsPhone;

      // Only enforce format on the channel they actually chose. Emptiness while
      // required is left to the native `required` message so we don't stack two
      // errors. Digit count is lenient: 10 (US) up to 15 (E.164 with country).
      const digits = this.phone.value.replace(/\D/g, '');
      const hasValue = this.phone.value.trim() !== '';
      const badFormat = needsPhone && hasValue && (digits.length < 10 || digits.length > 15);
      this.phone.setCustomValidity(badFormat ? this.phoneInvalidMsg : '');
    }

    /**
     * Reassures patients choosing a refill that the pharmacy team will follow
     * up, since this path intentionally offers nowhere to explain further.
     */
    syncRefillNotice() {
      const notice = this.form.querySelector('[data-refill-notice]');
      const selected = this.form.querySelector('[data-patient-reason]:checked');
      notice.hidden = !selected || selected.value !== 'refill_status';
    }

    syncOtherField(control) {
      const field = this.form.querySelector(
        `[data-other-field="${control.dataset.otherToggle}"]`
      );
      if (!field) return;

      const active =
        control.type === 'checkbox' ? control.checked : control.value === 'other';

      field.hidden = !active;
      field.disabled = !active;
      if (!active) field.value = '';
    }

    /** Serializes the form, collapsing `name[]` inputs into arrays. */
    buildPayload() {
      const payload = { page_url: window.location.href };

      new FormData(this.form).forEach((value, key) => {
        if (key.endsWith('[]')) {
          const name = key.slice(0, -2);
          if (!payload[name]) payload[name] = [];
          payload[name].push(value);
        } else {
          payload[key] = value;
        }
      });

      return payload;
    }

    setBusy(busy) {
      this.submit.disabled = busy;
      this.submitLabel.textContent = busy ? this.sendingLabel : this.defaultLabel;
    }

    async onSubmit(event) {
      event.preventDefault();

      // novalidate is set on the form so we can control when this fires.
      this.syncPhoneValidation();
      if (!this.form.reportValidity()) return;

      this.success.hidden = true;
      this.error.hidden = true;
      this.setBusy(true);

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.buildPayload()),
        });

        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        this.form.reset();
        this.syncBranches();
        this.form.querySelectorAll('[data-other-toggle]').forEach((el) => {
          this.syncOtherField(el);
        });
        this.success.hidden = false;
        this.success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        console.error('Contact form submission failed', error);
        this.error.hidden = false;
        this.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } finally {
        this.setBusy(false);
      }
    }
  }

  document.querySelectorAll('[data-contact-form]').forEach((form) => {
    // Without an endpoint the form has nowhere to post, so leave it inert
    // rather than letting a submit reload the page and lose the entry.
    if (!form.dataset.endpoint) {
      console.error('Contact form: no submission endpoint configured.');
      form.querySelector('button[type="submit"]').disabled = true;
      return;
    }

    new ContactForm(form);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmeceuticals"] && !Shopify.designMode) return;
  try {
    
  class CosmeceuticalsScroller {
    constructor(element) {
      this.scroller = element;
      this.track = this.scroller.querySelector('.cosmeceuticals__track');
      this.items = Array.from(this.scroller.querySelectorAll('.cosmeceuticals__item'));
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.hasMoved = false;
      this.animationFrame = null;

      this.init();
    }

    init() {
      // Update scales on scroll - use passive listener for better performance
      this.scroller.addEventListener('scroll', () => {
        this.updateScaledItems();
      }, { passive: true });

      // Scroll to center item on load - use timeout to ensure DOM is fully ready
      setTimeout(() => {
        if (this.items.length > 0) {
          // Calculate the center index (middle item)
          const centerIndex = Math.floor(this.items.length / 2);
          
          // Force initial update before scrolling
          this.updateScaledItems();
          
          // Scroll to center item within the scroller only (don't affect page scroll)
          const centerItem = this.items[centerIndex];
          const scrollerRect = this.scroller.getBoundingClientRect();
          const itemRect = centerItem.getBoundingClientRect();
          const scrollLeft = this.scroller.scrollLeft + (itemRect.left - scrollerRect.left) - (scrollerRect.width / 2) + (itemRect.width / 2);
          
          this.scroller.scrollLeft = scrollLeft;
          
          // Update scales after scroll for Chrome
          requestAnimationFrame(() => {
            this.updateScaledItems();
          });
        }
      }, 100);

      // Add smooth momentum scrolling with mouse drag
      this.scroller.addEventListener('mousedown', this.handleMouseDown.bind(this));
      this.scroller.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.scroller.addEventListener('mouseup', this.handleMouseUp.bind(this));
      this.scroller.addEventListener('mousemove', this.handleMouseMove.bind(this));

      // Prevent default drag behavior on images
      const images = this.scroller.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });
    }

    updateScaledItems() {
      const scrollerRect = this.scroller.getBoundingClientRect();
      const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
      
      // Get base width based on viewport
      let baseWidth = 550;
      if (window.innerWidth >= 1400) {
        baseWidth = 650;
      } else if (window.innerWidth <= 480) {
        baseWidth = 350;
      } else if (window.innerWidth <= 767) {
        baseWidth = 400;
      }

      this.items.forEach(item => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const distanceFromCenter = Math.abs(scrollerCenter - itemCenter);
        const maxDistance = scrollerRect.width / 2;
        
        // Calculate scale based on distance from center (closer = larger)
        // Scale ranges from 0.7 to 1.15 (15% larger at center)
        const normalizedDistance = Math.min(distanceFromCenter / maxDistance, 1);
        const scale = 1.15 - (normalizedDistance * 0.45);
        
        // Calculate opacity based on distance from center
        const opacity = 1 - (normalizedDistance * 0.4);

        // Apply width and opacity - this makes the spacing appear consistent
        const scaledWidth = baseWidth * scale;
        item.style.width = `${scaledWidth}px`;
        item.style.opacity = opacity;

        // Add/remove center class for the most centered item
        if (distanceFromCenter < itemRect.width / 2) {
          item.classList.add('is-center');
        } else {
          item.classList.remove('is-center');
        }
      });
    }

    handleMouseDown(e) {
      // Only drag with left mouse button
      if (e.button !== 0) return;
      
      this.isDragging = true;
      this.hasMoved = false;
      this.scroller.classList.add('is-dragging');
      this.scroller.style.cursor = 'grabbing';
      this.scroller.style.userSelect = 'none';
      this.startX = e.pageX - this.scroller.offsetLeft;
      this.scrollLeft = this.scroller.scrollLeft;
    }

    handleMouseLeave() {
      this.isDragging = false;
      this.scroller.classList.remove('is-dragging');
      this.scroller.style.cursor = 'grab';
      this.scroller.style.userSelect = '';
      this.scroller.style.scrollBehavior = '';
    }

    handleMouseUp() {
      this.isDragging = false;
      this.scroller.classList.remove('is-dragging');
      this.scroller.style.cursor = 'grab';
      this.scroller.style.userSelect = '';
      this.scroller.style.scrollBehavior = '';
      
      // Reset hasMoved after a small delay to allow click event to check it
      setTimeout(() => {
        this.hasMoved = false;
      }, 10);
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      
      e.preventDefault();
      const x = e.pageX - this.scroller.offsetLeft;
      const walk = (x - this.startX) * 1.5; // Scroll speed multiplier
      
      // If moved more than 5px, consider it a drag (not a click)
      if (Math.abs(walk) > 5) {
        this.hasMoved = true;
      }
      
      // Disable smooth scrolling during drag for immediate response
      this.scroller.style.scrollBehavior = 'auto';
      this.scroller.scrollLeft = this.scrollLeft - walk;
    }
  }

  // Initialize all brand showcase scrollers
  document.addEventListener('DOMContentLoaded', () => {
    const scrollers = document.querySelectorAll('.cosmeceuticals__scroller');
    scrollers.forEach(scroller => {
      new CosmeceuticalsScroller(scroller);
      scroller.style.cursor = 'grab';
    });
  });

  // Reinitialize on section reload (theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('cosmeceuticals')) {
        const scroller = event.target.querySelector('.cosmeceuticals__scroller');
        if (scroller) {
          new CosmeceuticalsScroller(scroller);
          scroller.style.cursor = 'grab';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-products-categories"] && !Shopify.designMode) return;
  try {
    
  class CustomProductsCatScroller {
    constructor(element) {
      this.scroller = element;
      this.track = element.querySelector('.custom-products-cat__track');
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.scrollLeft = 0;
      this.hasDragged = false;

      this.init();
    }

    init() {
      // Check if content fits without scrolling and center if so
      this.checkOverflow();
      window.addEventListener('resize', this.checkOverflow.bind(this));

      // Prevent default drag behavior on images
      const images = this.scroller.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      // Add drag listeners to the scroller
      this.scroller.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('mousemove', this.handleMouseMove.bind(this));
      document.addEventListener('mouseup', this.handleMouseUp.bind(this));

      // Prevent navigation on card links when the user was dragging
      const links = this.scroller.querySelectorAll('a.custom-products-cat__card--link');
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          if (this.hasDragged) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        });
      });
    }

    checkOverflow() {
      // Temporarily remove centered class to measure natural overflow
      this.track.classList.remove('custom-products-cat__track--centered');

      const isScrollable = this.scroller.scrollWidth > this.scroller.clientWidth;

      if (!isScrollable) {
        this.track.classList.add('custom-products-cat__track--centered');
      }
    }

    handleMouseDown(e) {
      // Only respond to left mouse button
      if (e.button !== 0) return;

      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.pageX;
      this.startY = e.pageY;
      this.scrollLeft = this.scroller.scrollLeft;

      this.scroller.style.cursor = 'grabbing';
      this.scroller.style.userSelect = 'none';
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;

      const deltaX = e.pageX - this.startX;

      // Check if user has moved more than 5px horizontally
      if (Math.abs(deltaX) > 5) {
        this.hasDragged = true;
        // Only flag dragging state once a real drag starts, so a plain
        // click never disables the card's pointer events (which would
        // otherwise stop the link from navigating).
        this.scroller.classList.add('is-dragging');
      }

      // Only scroll horizontally if there's horizontal movement
      if (Math.abs(deltaX) > 0) {
        this.scroller.scrollLeft = this.scrollLeft - deltaX;
      }
    }

    handleMouseUp() {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.scroller.classList.remove('is-dragging');
      this.scroller.style.cursor = 'grab';
      this.scroller.style.userSelect = '';

      // Reset hasDragged flag after a short delay
      setTimeout(() => {
        this.hasDragged = false;
      }, 10);
    }
  }

  // Initialize all custom product category scrollers
  document.addEventListener('DOMContentLoaded', () => {
    const scrollers = document.querySelectorAll('.custom-products-cat__scroller');
    scrollers.forEach(scroller => {
      new CustomProductsCatScroller(scroller);
      scroller.style.cursor = 'grab';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-products"] && !Shopify.designMode) return;
  try {
    
  class CustomProductsScroller {
    constructor(element) {
      this.scroller = element;
      this.track = element.querySelector('.custom-products__track');
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.scrollLeft = 0;
      this.hasDragged = false;

      this.init();
    }

    init() {
      // Check if content fits without scrolling and center if so
      this.checkOverflow();
      window.addEventListener('resize', this.checkOverflow.bind(this));

      // Prevent default drag behavior on images
      const images = this.scroller.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      // Add drag listeners to the scroller
      this.scroller.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('mousemove', this.handleMouseMove.bind(this));
      document.addEventListener('mouseup', this.handleMouseUp.bind(this));

      // Prevent clicks on links if user was dragging
      const links = this.scroller.querySelectorAll('a.custom-products__button');
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          if (this.hasDragged) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        });
      });
    }

    checkOverflow() {
      // Temporarily remove centered class to measure natural overflow
      this.track.classList.remove('custom-products__track--centered');

      const isScrollable = this.scroller.scrollWidth > this.scroller.clientWidth;

      if (!isScrollable) {
        this.track.classList.add('custom-products__track--centered');
      }
    }

    handleMouseDown(e) {
      // Only respond to left mouse button
      if (e.button !== 0) return;

      // Don't start dragging if clicking on a button link
      if (e.target.closest('a.custom-products__button')) {
        return;
      }

      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.pageX;
      this.startY = e.pageY;
      this.scrollLeft = this.scroller.scrollLeft;

      this.scroller.classList.add('is-dragging');
      this.scroller.style.cursor = 'grabbing';
      this.scroller.style.userSelect = 'none';
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;

      const deltaX = e.pageX - this.startX;

      // Check if user has moved more than 5px horizontally
      if (Math.abs(deltaX) > 5) {
        this.hasDragged = true;
      }

      // Only scroll horizontally if there's horizontal movement
      if (Math.abs(deltaX) > 0) {
        this.scroller.scrollLeft = this.scrollLeft - deltaX;
      }
    }

    handleMouseUp() {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.scroller.classList.remove('is-dragging');
      this.scroller.style.cursor = 'grab';
      this.scroller.style.userSelect = '';

      // Reset hasDragged flag after a short delay
      setTimeout(() => {
        this.hasDragged = false;
      }, 10);
    }
  }

  // Initialize all custom product scrollers
  document.addEventListener('DOMContentLoaded', () => {
    const scrollers = document.querySelectorAll('.custom-products__scroller');
    scrollers.forEach(scroller => {
      new CustomProductsScroller(scroller);
      scroller.style.cursor = 'grab';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  // Initialize FAQ page accordion functionality
  document.addEventListener('DOMContentLoaded', () => {
    const accordionButtons = document.querySelectorAll('.faq-page .faq-accordion-item__header');
    
    accordionButtons.forEach(button => {
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const content = button.nextElementSibling;
        
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  // Initialize FAQ accordion functionality
  document.addEventListener('DOMContentLoaded', () => {
    const accordionButtons = document.querySelectorAll('.faqs-section .accordion-item__header');
    
    accordionButtons.forEach(button => {
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const content = button.nextElementSibling;
        
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-rows"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.js-pfr-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (response.ok) {
          window.location.href = '/cart';
        } else {
          console.error('Failed to add item to cart');
          if (button) button.disabled = false;
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        if (button) button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductsScroller {
    constructor(element) {
      this.scroller = element;
      this.track = element.querySelector('.featured-products__track');
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.scrollLeft = 0;
      this.hasDragged = false;

      this.init();
    }

    init() {
      // Check if content fits without scrolling and center if so
      this.checkOverflow();
      window.addEventListener('resize', this.checkOverflow.bind(this));

      // Prevent default drag behavior on images
      const images = this.scroller.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      // Add drag listeners to the scroller
      this.scroller.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('mousemove', this.handleMouseMove.bind(this));
      document.addEventListener('mouseup', this.handleMouseUp.bind(this));

      // Prevent clicks on cards if user was dragging
      const cards = this.scroller.querySelectorAll('.featured-products__card');
      cards.forEach(card => {
        card.addEventListener('click', (e) => {
          if (this.hasDragged) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        });
      });
    }

    checkOverflow() {
      // Temporarily remove centered class to measure natural overflow
      this.track.classList.remove('featured-products__track--centered');

      const isScrollable = this.scroller.scrollWidth > this.scroller.clientWidth;

      if (!isScrollable) {
        this.track.classList.add('featured-products__track--centered');
      }
    }

    handleMouseDown(e) {
      // Only respond to left mouse button and only if clicking on the scroller itself
      if (e.button !== 0) return;
      
      // Don't start dragging if clicking directly on a link
      if (e.target.closest('.featured-products__card')) {
        return;
      }
      
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.pageX;
      this.startY = e.pageY;
      this.scrollLeft = this.scroller.scrollLeft;
      
      this.scroller.classList.add('is-dragging');
      this.scroller.style.cursor = 'grabbing';
      this.scroller.style.userSelect = 'none';
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      
      const deltaX = e.pageX - this.startX;
      const deltaY = e.pageY - this.startY;
      
      // Check if user has moved more than 5px horizontally
      if (Math.abs(deltaX) > 5) {
        this.hasDragged = true;
      }
      
      // Only scroll horizontally if there's horizontal movement
      if (Math.abs(deltaX) > 0) {
        this.scroller.scrollLeft = this.scrollLeft - deltaX;
      }
    }

    handleMouseUp() {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      this.scroller.classList.remove('is-dragging');
      this.scroller.style.cursor = 'grab';
      this.scroller.style.userSelect = '';
      
      // Reset hasDragged flag after a short delay
      setTimeout(() => {
        this.hasDragged = false;
      }, 10);
    }
  }

  // Initialize all featured product scrollers
  document.addEventListener('DOMContentLoaded', () => {
    const scrollers = document.querySelectorAll('.featured-products__scroller');
    scrollers.forEach(scroller => {
      new FeaturedProductsScroller(scroller);
      scroller.style.cursor = 'grab';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('[data-header]');
      this.scrollThreshold = 50;
      this.lastScrollY = 0;
      
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const scrollY = window.scrollY;
      
      if (scrollY > this.scrollThreshold) {
        this.header.classList.add('is-scrolled');
      } else {
        this.header.classList.remove('is-scrolled');
      }
      
      this.lastScrollY = scrollY;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function build(marquee) {
      var track = marquee.querySelector('.marquee-promo__track');
      if (!track) return;

      // Reset to the single source group so re-runs (resize/editor) recompute cleanly.
      var groups = track.querySelectorAll('.marquee-promo__group');
      for (var i = groups.length - 1; i >= 1; i--) {
        track.removeChild(groups[i]);
      }

      if (prefersReducedMotion()) {
        marquee.classList.remove('is-ready');
        return;
      }

      var source = track.querySelector('.marquee-promo__group');
      if (!source) return;

      var containerWidth = marquee.getBoundingClientRect().width;
      var groupWidth = source.getBoundingClientRect().width;
      if (containerWidth <= 0 || groupWidth <= 0) return;

      // Copies needed so ONE half overflows the viewport (+1 buffer). The track holds
      // two identical halves, so animating to -50% lands exactly on a repeat = seamless.
      var copiesPerHalf = Math.max(1, Math.ceil(containerWidth / groupWidth) + 1);
      var totalCopies = copiesPerHalf * 2;

      for (var c = 1; c < totalCopies; c++) {
        var clone = source.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      // Speed is pixels-per-second so velocity stays constant regardless of message length.
      var speed = parseFloat(marquee.getAttribute('data-speed')) || 60;
      var halfWidth = groupWidth * copiesPerHalf;
      var duration = halfWidth / speed;
      track.style.setProperty('--marquee-duration', duration + 's');

      marquee.classList.add('is-ready');
    }

    function init() {
      var marquees = document.querySelectorAll('.marquee-promo');
      marquees.forEach(function (marquee) {
        build(marquee);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Recalculate after fonts load and on resize so the loop stays seamless.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(init);
    }
    window.addEventListener('resize', function () {
      window.clearTimeout(window.__marqueePromoResize);
      window.__marqueePromoResize = window.setTimeout(init, 200);
    });

    // Re-init when re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pharmacy-services"] && !Shopify.designMode) return;
  try {
    
  class PharmacyServicesScroller {
    constructor(element) {
      this.scroller = element;
      this.track = this.scroller.querySelector('.pharmacy-services__track');
      this.cards = Array.from(this.scroller.querySelectorAll('.pharmacy-services__card'));
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.scrollLeft = 0;
      this.hasDragged = false;

      this.init();
    }

    init() {
      // Prevent default drag behavior on images
      const images = this.scroller.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      // Add drag listeners to the scroller
      this.scroller.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('mousemove', this.handleMouseMove.bind(this));
      document.addEventListener('mouseup', this.handleMouseUp.bind(this));

      // Prevent clicks on linked cards if user was dragging
      const linkedCards = this.scroller.querySelectorAll('.pharmacy-services__card--linked');
      linkedCards.forEach(card => {
        card.addEventListener('click', (e) => {
          if (this.hasDragged) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        });
      });

      // Set cursor style
      this.scroller.style.cursor = 'grab';
    }

    handleMouseDown(e) {
      // Only respond to left mouse button
      if (e.button !== 0) return;
      
      // Don't start dragging if clicking directly on a card
      if (e.target.closest('.pharmacy-services__card')) {
        return;
      }
      
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = e.pageX;
      this.startY = e.pageY;
      this.scrollLeft = this.scroller.scrollLeft;
      
      this.scroller.classList.add('is-dragging');
      this.scroller.style.cursor = 'grabbing';
      this.scroller.style.userSelect = 'none';
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      
      const deltaX = e.pageX - this.startX;
      const deltaY = e.pageY - this.startY;
      
      // Check if user has moved more than 5px horizontally
      if (Math.abs(deltaX) > 5) {
        this.hasDragged = true;
      }
      
      // Only scroll horizontally if there's horizontal movement
      if (Math.abs(deltaX) > 0) {
        this.scroller.scrollLeft = this.scrollLeft - deltaX;
      }
    }

    handleMouseUp() {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      this.scroller.classList.remove('is-dragging');
      this.scroller.style.cursor = 'grab';
      this.scroller.style.userSelect = '';
      
      // Reset hasDragged flag after a short delay
      setTimeout(() => {
        this.hasDragged = false;
      }, 10);
    }
  }

  // Initialize all pharmacy services scrollers
  document.addEventListener('DOMContentLoaded', () => {
    const scrollers = document.querySelectorAll('.pharmacy-services__scroller');
    scrollers.forEach(scroller => {
      new PharmacyServicesScroller(scroller);
    });
  });

  // Reinitialize on section reload (theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('pharmacy-services')) {
        const scroller = event.target.querySelector('.pharmacy-services__scroller');
        if (scroller) {
          new PharmacyServicesScroller(scroller);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pickup-checkin"] && !Shopify.designMode) return;
  try {
    
  /**
   * Curbside pickup check-in controller.
   *
   * Name, DOB and parking spot POSTed to n8n as JSON, which texts them to the
   * pharmacy. The DOB is entered in three numeric boxes and
   * sent as one YYYY-MM-DD `dob` value. `form_key` lets n8n reject requests
   * that didn't come from this form.
   */
  class PickupCheckin {
    constructor(form) {
      this.form = form;
      this.endpoint = form.dataset.endpoint;
      this.wrapper = form.closest('.pickup-checkin__wrapper');
      this.success = this.wrapper.querySelector('[data-checkin-success]');
      this.error = this.wrapper.querySelector('[data-checkin-error]');
      this.again = this.wrapper.querySelector('[data-checkin-again]');
      this.submit = form.querySelector('button[type="submit"]');
      this.submitLabel = this.submit.querySelector('.button-pill__text');
      this.defaultLabel = this.submitLabel.textContent;
      this.sendingLabel = form.dataset.sendingLabel || this.defaultLabel;
      this.dobInvalidMsg = form.dataset.dobInvalidMessage || 'Please enter a valid date of birth.';
      this.dob = {
        month: form.querySelector('[data-dob-part="month"]'),
        day: form.querySelector('[data-dob-part="day"]'),
        year: form.querySelector('[data-dob-part="year"]'),
      };

      this.bind();
    }

    bind() {
      // Move to the next box once month/day are filled, so the number pad stays up.
      this.dob.month.addEventListener('input', () => this.advance(this.dob.month, this.dob.day));
      this.dob.day.addEventListener('input', () => this.advance(this.dob.day, this.dob.year));
      this.form.querySelectorAll('[data-digits-only]').forEach((input) => {
        input.addEventListener('input', () => { input.value = input.value.replace(/\D/g, ''); });
      });
      this.again.addEventListener('click', () => this.reset());
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    advance(from, to) {
      from.value = from.value.replace(/\D/g, '');
      if (from.value.length === 2) to.focus();
    }

    /** Returns YYYY-MM-DD for a real, past calendar date, or null. */
    dobValue() {
      const month = parseInt(this.dob.month.value, 10);
      const day = parseInt(this.dob.day.value, 10);
      const year = parseInt(this.dob.year.value, 10);
      if (!month || !day || !year || year < 1900) return null;

      const date = new Date(Date.UTC(year, month - 1, day));
      const real = date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
      if (!real || date > new Date()) return null;

      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    }

    buildPayload(dob) {
      const data = new FormData(this.form);
      return {
        first_name: data.get('first_name'),
        last_name: data.get('last_name'),
        dob,
        parking_spot: data.get('parking_spot'),
        company_website: data.get('company_website'),
        form_key: this.form.dataset.formKey,
      };
    }

    setBusy(busy) {
      this.submit.disabled = busy;
      this.submitLabel.textContent = busy ? this.sendingLabel : this.defaultLabel;
    }

    reset() {
      this.form.reset();
      this.success.hidden = true;
      this.form.hidden = false;
      this.form.querySelector('input[name="first_name"]').focus();
    }

    async onSubmit(event) {
      event.preventDefault();
      // The date error lives on the month box but may be fixed in any of the three.
      this.dob.month.setCustomValidity('');
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      const dob = this.dobValue();
      if (!dob) {
        this.dob.month.setCustomValidity(this.dobInvalidMsg);
        this.dob.month.reportValidity();
        return;
      }

      this.error.hidden = true;
      this.setBusy(true);

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.buildPayload(dob)),
        });
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        // Hide the form rather than leave it filled, so a second tap can't re-send.
        this.form.reset();
        this.form.hidden = true;
        this.success.hidden = false;
        this.success.focus({ preventScroll: true });
        // The form collapses, so go to the top where the confirmation now sits
        // (centering it would tuck the heading under the sticky header).
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (error) {
        console.error('Pickup check-in submission failed', error);
        this.error.hidden = false;
        this.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } finally {
        this.setBusy(false);
      }
    }
  }

  document.querySelectorAll('[data-checkin-form]').forEach((form) => {
    if (!form.dataset.endpoint) {
      console.error('Pickup check-in: no submission endpoint configured.');
      form.querySelector('button[type="submit"]').disabled = true;
      return;
    }
    new PickupCheckin(form);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-promo"]) return;
  try {
    
  const POPUP_SESSION_KEY = 'ddl_promo_popup_dismissed';

  class PopupPromo extends HTMLElement {
    constructor() {
      super();
      this.popup = this.querySelector('[data-popup-promo]');
      this.overlay = this.querySelector('[data-popup-overlay]');
      this.closeButton = this.querySelector('[data-popup-close]');

      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onEscapeKey = this.onEscapeKey.bind(this);
    }

    connectedCallback() {
      if (localStorage.getItem(POPUP_SESSION_KEY)) return;

      this.overlay?.addEventListener('click', this.onOverlayClick);
      this.closeButton?.addEventListener('click', this.onCloseClick);

      setTimeout(() => this.open(), 1500);
    }

    disconnectedCallback() {
      this.overlay?.removeEventListener('click', this.onOverlayClick);
      this.closeButton?.removeEventListener('click', this.onCloseClick);
      document.removeEventListener('keydown', this.onEscapeKey);
    }

    open() {
      this.popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onEscapeKey);
      this.closeButton?.focus();
    }

    close() {
      this.popup.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onEscapeKey);
      localStorage.setItem(POPUP_SESSION_KEY, 'true');
    }

    onOverlayClick() {
      this.close();
    }

    onCloseClick() {
      this.close();
    }

    onEscapeKey(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }

  if (!customElements.get('popup-promo')) {
    customElements.define('popup-promo', PopupPromo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Initialize accordion functionality
  document.addEventListener('DOMContentLoaded', () => {
    const accordionButtons = document.querySelectorAll('.product-page .accordion-item__header, .product-overview .accordion-item__header');
    
    accordionButtons.forEach(button => {
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const content = button.nextElementSibling;
        
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
      });
    });
  });

  // Handle variant option selection
  const variantDataEl = document.querySelector('[data-product-variants]');
  if (variantDataEl) {
    const variants = JSON.parse(variantDataEl.textContent);
    const variantIdInput = document.querySelector('[data-variant-id]');
    const selects = document.querySelectorAll('.product-page__variant-select');
    const addToCartBtn = document.querySelector('.product-page__add-to-cart');

    const priceDataEl = document.querySelector('[data-variant-prices]');
    const variantPrices = priceDataEl ? JSON.parse(priceDataEl.textContent) : {};
    const priceDisplay = document.querySelector('[data-price-display]');

    const imageDataEl = document.querySelector('[data-variant-images]');
    const variantImages = imageDataEl ? JSON.parse(imageDataEl.textContent) : {};
    const productImage = document.querySelector('img.product-page__image');

    function updatePrice(variantId) {
      if (!priceDisplay) return;

      const priceInfo = variantPrices[variantId];
      if (!priceInfo) return;

      priceDisplay.textContent = '';

      const priceEl = document.createElement('span');
      priceEl.className = 'product-page__price';
      priceEl.textContent = priceInfo.price;

      if (priceInfo.onSale) {
        priceEl.classList.add('product-page__price--sale');
        priceDisplay.appendChild(priceEl);

        const compareEl = document.createElement('span');
        compareEl.className = 'product-page__compare-price';
        compareEl.textContent = priceInfo.compareAtPrice;
        priceDisplay.appendChild(compareEl);
      } else {
        priceDisplay.appendChild(priceEl);
      }
    }

    function updateImage(variantId) {
      if (!productImage) return;

      const image = variantImages[variantId];
      if (!image || !image.src) return;

      // The server-rendered img has a responsive srcset; the browser
      // picks from srcset and ignores src, which would defeat the
      // swap. Drop srcset/sizes so the new src is what renders.
      productImage.removeAttribute('srcset');
      productImage.removeAttribute('sizes');
      productImage.src = image.src;
      if (image.alt) {
        productImage.alt = image.alt;
      }
    }

    function updateVariant() {
      const selectedOptions = Array.from(selects).map(select => select.value);
      const matchedVariant = variants.find(variant =>
        variant.options.every((opt, index) => opt === selectedOptions[index])
      );

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;
        if (addToCartBtn) {
          addToCartBtn.disabled = !matchedVariant.available;
        }
        updatePrice(matchedVariant.id);
        updateImage(matchedVariant.id);
      }
    }

    selects.forEach(select => {
      select.addEventListener('change', updateVariant);
    });
  }

  // Handle add to cart form submission
  const productForm = document.getElementById('product-form');
  if (productForm) {
    const formError = productForm.querySelector('[data-product-form-error]');
    let submitting = false;

    function clearFormErrors() {
      if (formError) {
        formError.hidden = true;
        formError.textContent = '';
      }
      productForm.querySelectorAll('[data-recipient-error]').forEach(slot => {
        slot.hidden = true;
        slot.textContent = '';
      });
      productForm.querySelectorAll('[data-recipient-field]').forEach(field => {
        field.removeAttribute('aria-invalid');
      });
    }

    // Shopify returns field errors keyed email, name, message and send_on for
    // gift card recipients, and a description string for everything else
    // (sold out, quantity limits). Field errors go under their field; the
    // box above the button always gets a summary.
    function showFormErrors(result) {
      let fieldErrorShown = false;

      if (result && result.errors && typeof result.errors === 'object') {
        Object.entries(result.errors).forEach(([key, messages]) => {
          const slot = productForm.querySelector(`[data-recipient-error="${key}"]`);
          if (!slot) return;
          slot.textContent = [].concat(messages).join(', ');
          slot.hidden = false;
          const field = productForm.querySelector(`[data-recipient-field="${key}"]`);
          if (field) field.setAttribute('aria-invalid', 'true');
          fieldErrorShown = true;
        });
      }

      if (!formError) return;

      let message = formError.dataset.defaultMessage;
      if (fieldErrorShown) {
        message = formError.dataset.fieldsMessage;
      } else if (result && typeof result.description === 'string' && result.description) {
        message = result.description;
      }
      formError.textContent = message;
      formError.hidden = false;

      const firstInvalid = productForm.querySelector('[aria-invalid="true"]');
      if (firstInvalid) firstInvalid.focus();
    }

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (submitting) return;
      submitting = true;
      clearFormErrors();

      const formData = new FormData(productForm);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          window.location.href = '/cart';
        } else {
          const result = await response.json().catch(() => null);
          showFormErrors(result);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        showFormErrors(null);
      } finally {
        submitting = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["provider-signup"] && !Shopify.designMode) return;
  try {
    
  /**
   * Provider signup controller.
   *
   * A long, mostly-flat intake that POSTs to n8n as JSON. Conditional pieces:
   * "Other" specify inputs, a telehealth explanation shown when the telehealth
   * setting is chosen, and two multi-select groups that require at least one
   * choice. Hidden/conditional inputs are `disabled` so they neither submit nor
   * block validation.
   */
  class ProviderForm {
    constructor(form) {
      this.form = form;
      this.endpoint = form.dataset.endpoint;
      this.wrapper = form.closest('.provider-form__wrapper');
      this.success = this.wrapper.querySelector('[data-signup-success]');
      this.error = this.wrapper.querySelector('[data-signup-error]');
      this.submit = form.querySelector('button[type="submit"]');
      this.submitLabel = this.submit.querySelector('.button-pill__text');
      this.defaultLabel = this.submitLabel.textContent;
      this.sendingLabel = form.dataset.sendingLabel || this.defaultLabel;
      this.requireOneMsg = form.dataset.requireOneMessage || 'Please select at least one option.';

      this.bind();
      this.syncAllOther();
      this.syncTelehealth();
      this.syncRequireOneGroups();
    }

    bind() {
      this.form.querySelectorAll('[data-other-toggle]').forEach((el) => {
        el.addEventListener('change', () => this.syncOtherField(el));
      });
      this.form.querySelectorAll('[data-telehealth-toggle]').forEach((el) => {
        el.addEventListener('change', () => this.syncTelehealth());
      });
      this.form.querySelectorAll('[data-require-one] [data-require-one-input]').forEach((el) => {
        el.addEventListener('change', () => this.syncRequireOneGroups());
      });
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    syncAllOther() {
      this.form.querySelectorAll('[data-other-toggle]').forEach((el) => this.syncOtherField(el));
    }

    syncOtherField(control) {
      const field = this.form.querySelector(`[data-other-field="${control.dataset.otherToggle}"]`);
      if (!field) return;
      const active = control.type === 'checkbox' ? control.checked : control.value === 'other';
      field.hidden = !active;
      field.disabled = !active;
      if (!active) field.value = '';
    }

    /** Telehealth SOP box appears only when the telehealth setting is checked. */
    syncTelehealth() {
      const toggle = this.form.querySelector('[data-telehealth-toggle]');
      const wrap = this.form.querySelector('[data-telehealth-explain]');
      const field = wrap.querySelector('textarea');
      const active = !!toggle && toggle.checked;
      wrap.hidden = !active;
      field.disabled = !active;
      if (!active) field.value = '';
    }

    /** Each [data-require-one] group must have at least one box checked. */
    syncRequireOneGroups() {
      this.form.querySelectorAll('[data-require-one]').forEach((group) => {
        const inputs = Array.from(group.querySelectorAll('[data-require-one-input]'));
        const anyChecked = inputs.some((i) => i.checked);
        if (inputs[0]) inputs[0].setCustomValidity(anyChecked ? '' : this.requireOneMsg);
      });
    }

    /** Serializes the form, collapsing `name[]` inputs into arrays. */
    buildPayload() {
      const payload = { page_url: window.location.href };
      new FormData(this.form).forEach((value, key) => {
        if (key.endsWith('[]')) {
          const name = key.slice(0, -2);
          if (!payload[name]) payload[name] = [];
          payload[name].push(value);
        } else {
          payload[key] = value;
        }
      });
      return payload;
    }

    setBusy(busy) {
      this.submit.disabled = busy;
      this.submitLabel.textContent = busy ? this.sendingLabel : this.defaultLabel;
    }

    async onSubmit(event) {
      event.preventDefault();
      this.syncRequireOneGroups();
      if (!this.form.reportValidity()) return;

      this.success.hidden = true;
      this.error.hidden = true;
      this.setBusy(true);

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.buildPayload()),
        });
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        this.form.reset();
        this.syncAllOther();
        this.syncTelehealth();
        this.syncRequireOneGroups();
        this.success.hidden = false;
        this.success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        console.error('Provider signup submission failed', error);
        this.error.hidden = false;
        this.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } finally {
        this.setBusy(false);
      }
    }
  }

  document.querySelectorAll('[data-signup-form]').forEach((form) => {
    if (!form.dataset.endpoint) {
      console.error('Provider signup: no submission endpoint configured.');
      form.querySelector('button[type="submit"]').disabled = true;
      return;
    }
    new ProviderForm(form);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resource-scroller"] && !Shopify.designMode) return;
  try {
    
  class ResourceScroller {
    constructor(root) {
      this.root = root;
      this.scroller = root.querySelector('[data-scroller]');
      this.track = root.querySelector('[data-track]');
      this.empty = root.querySelector('[data-empty]');
      if (!this.scroller || !this.track) return;

      this.cards = Array.from(this.track.querySelectorAll('[data-card]'));
      this.chips = Array.from(root.querySelectorAll('[data-filter-chip]'));
      this.authorSelect = root.querySelector('[data-filter-author]');
      this.sortSelect = root.querySelector('[data-sort-select]');

      this.category = '';
      this.author = '';
      this.sort = this.sortSelect ? this.sortSelect.value : 'featured';

      // Parsed once: a text date that JS can't read falls back to block order,
      // which keeps the merchant's manual arrangement as the tiebreaker.
      this.cards.forEach((card, index) => {
        const parsed = Date.parse(card.dataset.date || '');
        card.__order = index;
        card.__time = Number.isNaN(parsed) ? null : parsed;
      });

      this.bind();
      this.apply();
    }

    bind() {
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          this.category = chip.getAttribute('value') || '';
          this.chips.forEach((other) => {
            const active = other === chip;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.apply();
        });
      });

      if (this.authorSelect) {
        this.authorSelect.addEventListener('change', () => {
          this.author = this.authorSelect.value;
          this.apply();
        });
      }

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => {
          this.sort = this.sortSelect.value;
          this.apply();
        });
      }

      this.onResize = this.checkOverflow.bind(this);
      window.addEventListener('resize', this.onResize);
    }

    apply() {
      let visible = 0;

      this.cards.forEach((card) => {
        const matchesCategory = !this.category || card.dataset.category === this.category;
        const matchesAuthor = !this.author || card.dataset.author === this.author;
        const show = matchesCategory && matchesAuthor;
        card.hidden = !show;
        if (show) visible += 1;
      });

      this.sortCards();

      if (this.empty) this.empty.hidden = visible > 0;
      this.scroller.hidden = visible === 0;

      this.checkOverflow();
    }

    sortCards() {
      // Flexbox `order` avoids touching the DOM, so focus and scroll position survive.
      const ordered = this.cards.slice();

      if (this.sort === 'latest' || this.sort === 'oldest') {
        const direction = this.sort === 'latest' ? -1 : 1;
        ordered.sort((a, b) => {
          // Undated cards sink to the bottom rather than sorting as epoch zero.
          if (a.__time === null && b.__time === null) return a.__order - b.__order;
          if (a.__time === null) return 1;
          if (b.__time === null) return -1;
          if (a.__time === b.__time) return a.__order - b.__order;
          return (a.__time - b.__time) * direction;
        });
      } else {
        ordered.sort((a, b) => a.__order - b.__order);
      }

      ordered.forEach((card, index) => {
        card.style.order = String(index);
      });
    }

    checkOverflow() {
      this.track.classList.remove('resource-scroller__track--centered');
      if (this.scroller.scrollWidth <= this.scroller.clientWidth) {
        this.track.classList.add('resource-scroller__track--centered');
      }
    }
  }

  function initResourceScrollers(scope) {
    (scope || document).querySelectorAll('[data-resource-scroller]').forEach((el) => {
      if (el.__resourceScroller) return;
      el.__resourceScroller = new ResourceScroller(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initResourceScrollers());
  } else {
    initResourceScrollers();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => initResourceScrollers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-steps"] && !Shopify.designMode) return;
  try {
    
  class ScrollSteps extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.ticking = false;
      this.activeIndex = -1;
    }

    connectedCallback() {
      this.scroller = this.querySelector('.scroll-steps__scroll');
      this.steps = Array.from(this.querySelectorAll('.scroll-steps__step'));
      this.mobileQuery = window.matchMedia('(max-width: 767px)');

      if (!this.scroller || this.steps.length === 0) return;

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    onResize() {
      this.update();
    }

    update() {
      // On mobile the pin is disabled; show every step.
      if (this.mobileQuery.matches) {
        if (this.activeIndex !== -2) {
          this.steps.forEach((step) => step.classList.add('is-active'));
          this.activeIndex = -2;
        }
        return;
      }

      const rect = this.scroller.getBoundingClientRect();
      const distance = this.scroller.offsetHeight - window.innerHeight;
      let progress = 0;
      if (distance > 0) {
        progress = (0 - rect.top) / distance;
      }
      progress = Math.min(Math.max(progress, 0), 1);

      const count = this.steps.length;
      let index = Math.floor(progress * count);
      index = Math.min(Math.max(index, 0), count - 1);

      this.setActive(index);
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      this.steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === index);
      });
    }
  }

  if (!customElements.get('scroll-steps')) {
    customElements.define('scroll-steps', ScrollSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSlider {
    constructor(element) {
      this.slider = element;
      this.slides = this.slider.querySelectorAll('.testimonials__slide');
      this.dots = this.slider.querySelectorAll('.testimonials__dot');
      const wrapper = this.slider.closest('.testimonials__wrapper');
      this.prevButton = wrapper ? wrapper.querySelector('[data-testimonials-prev]') : null;
      this.nextButton = wrapper ? wrapper.querySelector('[data-testimonials-next]') : null;
      this.currentIndex = 0;
      this.autoplay = this.slider.dataset.autoplay === 'true';
      this.interval = parseInt(this.slider.dataset.interval) || 5000;
      this.autoplayTimer = null;
      this.isPaused = false;

      this.init();
    }

    init() {
      if (this.slides.length === 0) return;

      // Show first slide
      this.showSlide(0);

      // Add dot click handlers
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goToSlide(index);
        });
      });

      // Add arrow button handlers
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.previousSlide();
          this.resetAutoplay();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.nextSlide();
          this.resetAutoplay();
        });
      }

      // Keyboard navigation
      this.slider.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          this.nextSlide();
        }
      });

      // Pause on hover
      this.slider.addEventListener('mouseenter', () => {
        this.pauseAutoplay();
      });

      this.slider.addEventListener('mouseleave', () => {
        this.resumeAutoplay();
      });

      // Touch swipe support
      this.addSwipeSupport();

      // Start autoplay
      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    showSlide(index) {
      // Remove active class from all slides and dots
      this.slides.forEach(slide => slide.classList.remove('is-active'));
      this.dots.forEach(dot => dot.classList.remove('is-active'));

      // Add active class to current slide and dot
      if (this.slides[index]) {
        this.slides[index].classList.add('is-active');
      }
      if (this.dots[index]) {
        this.dots[index].classList.add('is-active');
      }

      this.currentIndex = index;
    }

    goToSlide(index) {
      this.showSlide(index);
      this.resetAutoplay();
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.showSlide(nextIndex);
    }

    previousSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.showSlide(prevIndex);
    }

    startAutoplay() {
      if (!this.autoplay || this.isPaused) return;
      
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    pauseAutoplay() {
      this.isPaused = true;
      this.stopAutoplay();
    }

    resumeAutoplay() {
      this.isPaused = false;
      this.startAutoplay();
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    addSwipeSupport() {
      let touchStartX = 0;
      let touchEndX = 0;

      this.slider.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      });

      this.slider.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      });

      const handleSwipe = () => {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            // Swipe left - next slide
            this.nextSlide();
          } else {
            // Swipe right - previous slide
            this.previousSlide();
          }
          this.resetAutoplay();
        }
      };

      this.handleSwipe = handleSwipe;
    }
  }

  // Initialize all testimonials sliders
  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('[data-testimonials-slider]');
    sliders.forEach(slider => new TestimonialsSlider(slider));
  });

  // Reinitialize on Shopify section load (theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const slider = event.target.querySelector('[data-testimonials-slider]');
      if (slider) {
        new TestimonialsSlider(slider);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  function initVideoSection(scope) {
    // Swap the cover for the player on click, so nothing loads until then.
    // Pop-up covers are handled by the video-popup snippet.
    (scope || document).querySelectorAll('[data-video-section-play]').forEach((button) => {
      if (button.dataset.videoSectionBound === 'true') return;
      button.dataset.videoSectionBound = 'true';

      button.addEventListener('click', () => {
        const player = button.closest('.video-section__player');
        const template = player && player.querySelector('template');
        if (!template) return;

        player.appendChild(template.content.cloneNode(true));
        button.remove();

        const media = player.querySelector('iframe, video');
        if (!media) return;
        media.focus();
        if (media.tagName === 'VIDEO') media.play().catch(() => {});
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVideoSection());
  } else {
    initVideoSection();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => initVideoSection(event.target));

  } catch(e) { console.error(e); }
})();
})();
